import { helper } from '@ember/component/helper';

import { formatDate, parseDate } from 'rise-ui/utils/date.js';

export default helper(function qpDateHelper([ date, keyPos, dateFormat ], { key, format }) {
  if (Array.isArray(date)) {
    date = date[0];
  }
  key = key || keyPos;
  if (date && key) {
    date = date[key];
  }
  date = parseDate(date, 'url');
  return formatDate(date, format || dateFormat);
});
